import { PayloadAction } from '@reduxjs/toolkit';
import { put, select } from 'redux-saga/effects';
import { audioIsolated } from 'features/local-mute/localMuteSlice';
import { selectAvailableUserIdsWithoutLocal } from 'features/users/usersSlice';
import { UserId } from 'features/users/types';

export function* isolateAudioSaga(action: PayloadAction<UserId>) {
  const userIds: UserId[] = yield select(selectAvailableUserIdsWithoutLocal);

  const mutedUserIds: Record<UserId, true> = {};
  for (const id of userIds) {
    if (id !== action.payload) {
      mutedUserIds[id] = true;
    }
  }

  yield put(audioIsolated({ focusUserId: action.payload, mutedUserIds }));
}
